import { WHO_WE_SERVE } from "../data/content";
import { Reveal } from "./Reveal";

export const WhoWeServe = ({ compact = false }) => {
  return (
    <section
      id="who-we-serve"
      data-testid="who-we-serve-section"
      className={`${compact ? "py-10 sm:py-14 lg:py-16" : "py-16 sm:py-20 lg:py-28"} bg-brand-charcoal grain`}
    >
      <div className="relative max-w-7xl mx-auto px-5 sm:px-6 lg:px-10">
        {!compact && (
          <div className="max-w-3xl">
            <Reveal>
              <p className="text-[12px] font-bold uppercase tracking-[0.22em] text-brand-gold">
                Who We Serve
              </p>
            </Reveal>
            <Reveal delay={1}>
              <h2 className="mt-3 font-display font-black text-3xl sm:text-4xl lg:text-5xl tracking-tight text-white leading-[1.05]">
                Built for More
                <br />
                Than Parties.
              </h2>
            </Reveal>
            <Reveal delay={2}>
              <p className="mt-5 text-[15px] lg:text-[17px] text-white/70 leading-relaxed max-w-2xl">
                From DOE-vendor school programs to corporate offices, agency meetings,
                production shoots, and airport concessions — we&rsquo;re built to scale.
              </p>
            </Reveal>
          </div>
        )}

        <div className={`${compact ? "" : "mt-12 sm:mt-14"} grid grid-cols-2 lg:grid-cols-5 gap-3`}>
          {WHO_WE_SERVE.map((w, i) => (
            <Reveal key={w.title} delay={Math.min((i % 5) + 1, 5)}>
              <div
                data-testid={`who-serve-${w.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className="group h-full rounded-2xl bg-white/[0.04] border border-white/10 p-5 transition-all hover:bg-white/[0.08] hover:border-brand-teal/60 hover:-translate-y-0.5"
              >
                <p className="font-display font-bold text-white text-[16.5px] leading-tight tracking-tight group-hover:text-brand-gold transition-colors">
                  {w.title}
                </p>
                <p className="mt-2 text-[12.5px] text-white/65 leading-snug">{w.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhoWeServe;
